import Container from 'components/Container'
import { MDXLayoutRenderer } from 'components/MDXComponents'
import { allAuthors } from 'contentlayer/generated'
import { InferGetStaticPropsType } from 'next'

const DEFAULT_LAYOUT = 'AuthorLayout'

// @ts-ignore
export const getStaticProps = async () => {
  const author = allAuthors.find((a) => a._raw.sourceFileName.includes('default'))
  return { props: { author } }
}

export default function About({ author }: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <Container>
      <MDXLayoutRenderer layout={author.layout || DEFAULT_LAYOUT} content={author} />
    </Container>
  )
}
